import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {CONSTANT_APIS} from "@shared/constant";
import {environment} from "@environments/environment";
import {Observable} from "rxjs";
import {ToastService} from "@shared/services/toast.service";


@Injectable({
  providedIn: 'root'
})
export class DataService {
  constructor(private http: HttpClient, private toast: ToastService) {
  }

  public getStoreCategories(){
    return this.http.get(CONSTANT_APIS.CATEGORIES_LIST);
  }
  public getStoreCountries(){
    return this.http.get(CONSTANT_APIS.COUNTRIES_LIST);
  }
  public uploadImage(file: File) : Promise<any> {
    return new Promise((resolve, reject) => {
      const formData: any = new FormData();
      const xhr = new XMLHttpRequest();

      formData.append('file', file, file.name);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      };
      xhr.onerror = (err) => {
        console.error(err);
        if (!navigator.onLine) {
          this.toast.error('No Internet Connection');
        }
        reject(err);
      };
      xhr.open('POST', environment.endPoint + 'files/redeem/upload', true);
      xhr.withCredentials = false;
      xhr.send(formData);
    });
  }
  public sendCSV(email: any, path: any, par: any) {
    const raw = (par && typeof par === 'object' && !Array.isArray(par)) ? { ...par } : {};
    delete raw.page;
    const params: { [key: string]: string } = { email: String(email) };
    Object.keys(raw).forEach((key) => {
      const value = raw[key];
      if (value !== undefined && value !== null && value !== '') {
        params[key] = String(value);
      }
    });
    return this.http.get(path, { params });
  }

}
